export default "__VITE_ASSET__CReSPPn8__"